module.exports = __webpack_public_path__ + "e6790b7fe7a1b37a336dbeefac3a0a68.png";